/**
 * Silberfluss API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.10
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ThreadLastSeen { 
    lastSeen?: string;
    type?: ThreadLastSeen.TypeEnum;
    userId?: string;
}
export namespace ThreadLastSeen {
    export type TypeEnum = 'lawyer' | 'client';
    export const TypeEnum = {
        Lawyer: 'lawyer' as TypeEnum,
        Client: 'client' as TypeEnum
    };
}


